import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/** Window plus any page shell marked data-scroll-root (admin main, auth overlay). */
function scrollPageToTop() {
  window.scrollTo(0, 0);
  const scrolling = document.scrollingElement || document.documentElement;
  scrolling.scrollTop = 0;
  document.body.scrollTop = 0;
  document.querySelectorAll("[data-scroll-root]").forEach((node) => {
    node.scrollTop = 0;
  });
}

/**
 * Every route opens at the top. Browser scroll restoration is turned off so a
 * refresh does not reopen a page halfway down.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    const onPageShow = (event) => {
      if (event.persisted) scrollPageToTop();
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  useLayoutEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const target = id ? document.getElementById(id) : null;
      if (target) {
        target.scrollIntoView({ block: "start" });
        return;
      }
    }
    scrollPageToTop();
  }, [pathname, hash]);

  return null;
}
